import type { Color } from "@mui/material";
import { blue, green, grey, indigo, orange, purple, teal } from "@mui/material/colors";

const ORDER_LIST_SYSTEM_CHIP_HUES: Record<string, Color> = {
  CIN7: blue,
  SHOPIFY: green,
  TOE: purple,
  TOLL: orange,
  ESTORE: teal,
  SPS: indigo,
};

/** The fixed hue for an external system (colour means which system, never status); unknown systems are grey. */
export const orderListSystemChipHue = (system: string): Color => {
  return ORDER_LIST_SYSTEM_CHIP_HUES[system] ?? grey;
};
